import { ErrorWrapper, ResponseWrapper } from '../util'
import { BaseService } from './../base'

export class UserCellarService extends BaseService {
  static get entity () {
    return 'user_cellar'
  }
  static get name () {
    return 'user_cellar'
  }

  static async getCellarFindByUser () {
    try {
      const response = await this.request().get(`${this.profile}/${this.entity}/find_by_user_id`)
      return new ResponseWrapper(response, response.data[this.name])
    } catch (error) {
      throw new ErrorWrapper(error)
      // return;
    }
  }
}